import api from "@/api/axios";
export default {
  namespaced: true,
  state: {
    reasons: [],
  },
  mutations: {
    SET_REASONS(state, payload) {
      state.reasons = payload;
    },
  },
  actions: {
    async getReasons({ commit }) {
      try {
        commit("setLoading", true, { root: true });

        await api
          .get("/admin/reasons", {
            params: {
              all: 1,
            },
          })
          .then((res) => {
            commit("SET_REASONS", res.data.data);
          });

        commit("setLoading", false, { root: true });
      } catch (error) {
        // commit('setLoading', false, { root: true })
        return error;
      }
    },
  },
};
